import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendarLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16 3C16.5128 3 16.9355 3.38604 16.9933 3.88338L17 4V5H19C20.0544 5 20.9182 5.81588 20.9945 6.85074L21 7V19C21 20.0544 20.1841 20.9182 19.1493 20.9945L19 21H5C3.94564 21 3.08183 20.1841 3.00549 19.1493L3 19V7C3 5.94564 3.81588 5.08183 4.85074 5.00549L5 5H7V4C7 3.44772 7.44772 3 8 3C8.51283 3 8.93551 3.38604 8.99327 3.88338L9 4V5H15V4C15 3.44772 15.4477 3 16 3ZM19 12H5V19H19V12ZM19 7H5V10H19V7Z" })
});
export default SvgCalendarLine;
